/**
 * App Theme - Fonts
 *
 * React Native Starter App
 * https://github.com/mcnamee/react-native-starter-app
 */
import { Platform } from "react-native";

function lineHeight(fontSize) {
    const multiplier = (fontSize > 20) ? 0.1 : 0.33;
    return parseInt(fontSize + (fontSize * multiplier), 10);
}

const base = {
    size: 14,
    lineHeight: lineHeight(14),
    family: "Arial, Helvetica, sans-serif, \"Microsoft YaHei\", \"微软雅黑\", SimSun, \"宋体\"",
};

export default {
    base: { ...base },
    h1: { ...base, size: base.size * 1.75, lineHeight: lineHeight(base.size * 2) },
    h2: { ...base, size: base.size * 1.5, lineHeight: lineHeight(base.size * 1.75) },
    h3: { ...base, size: base.size * 1.25, lineHeight: lineHeight(base.size * 1.5) },
    h4: { ...base, size: base.size * 1.1, lineHeight: lineHeight(base.size * 1.25) },
    h5: { ...base },

    textSizeBase: (Platform.OS === "ios") ? 17 : 14,
    textSizeMd: (Platform.OS === "ios") ? 20 : 17,
    textSizeSmall: (Platform.OS === "ios") ? 14 : 12,
    whiteLabelIcon:  (Platform.OS === "ios") ? 32 : 30,
};
